__turbopack_context__.v({
  "copy": "planner-bubble-module__BUTRUq__copy",
  "copy-in": "planner-bubble-module__BUTRUq__copy-in",
  "dot": "planner-bubble-module__BUTRUq__dot",
  "hello": "planner-bubble-module__BUTRUq__hello",
  "shimmer": "planner-bubble-module__BUTRUq__shimmer",
});
